import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "ui/components/dialog";

import { Button } from "ui/components/button";
import ButtonWithLoading from "@/components/button-with-loading";

export default function AcknowledgmentDialog({
  open,
  onOpenChange,
  onConfirm,
  isLoading,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Are you sure?</DialogTitle>
          <DialogDescription>
            Are you sure you want to acknowledge your timesheet for today
            without logging any hours?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <ButtonWithLoading
            onClick={onConfirm}
            isLoading={isLoading}
            disabled={isLoading}
            variant="default"
          >
            Yes, Acknowledge
          </ButtonWithLoading>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
